import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => page => ');

/**
 * actions for fecthing pages
 */
const fetchPages = createAction('fetch pages', (experienceId) => ({ experienceId }));
const fetchPagesFailure = createApiFailureAction('failed to fetch pages');
const fetchPagesSuccess = createAction('succesfully fetched pages', (pages) => ({
  pages,
}));

/**
 * actions for saving pages
 */
const updatePage = createAction('update page', (page) => ({ page }));
const updatePageFailure = createApiFailureAction('failed to update page', (page) => ({ page }));
const updatePageSuccess = createAction('succesfully updated page');

const savePages = createAction('save pages', (unsavedLayouts) => ({ unsavedLayouts }));
const applyPages = createAction('apply pages', (unsavedLayouts) => ({ unsavedLayouts }));
const finishSaving = createAction('finish saving');
const savePagesFailure = createApiFailureAction('failed to save pages');
const savePagesSuccess = createAction('succesfully saved page', (closeDesigner) => ({ closeDesigner }));
const receiveUpdatedPage = createAction('receive an updated page from the page save api', (page) => ({ page }));

// Delete page.
const deletePage = createAction('delete page', (id) => ({ id }));
const deletePageSuccess = createAction('succesfully deleted page', (id) => ({ id }));
const deletePageFailure = createApiFailureAction('failed to delete page');

//persist new page order
const setByPhase = createAction('set by phase', (byPhase) => ({ byPhase }));
const savePageOrder = createAction('save page order', (currentByPhase, reorderedByPhase) => ({
  currentByPhase,
  reorderedByPhase,
}));
const savePageOrderSuccess = createAction('save page order success');
const savePageOrderFailure = createApiFailureAction('save page order failure');

const changePageStatus = createAction('change page status update in the state', (id, status) => ({ id, status }));

/**
 * actions for fecthing emptyPhases
 */
const fetchEmptyPhases = createAction('fetch empty phases');
const fetchEmptyPhasesSuccess = createAction('succesfully fetched pages', (emptyPhases) => ({
  emptyPhases,
}));
const fetchEmptyPhasesFailure = createApiFailureAction('failed to fetch empty phases');

const reorderPagesInPhase = createAction('reorder pages in a phase', (phase, startIndex, endIndex) => ({
  phase,
  startIndex,
  endIndex,
}));

export default {
  fetchPages,
  fetchPagesSuccess,
  fetchPagesFailure,
  updatePage,
  savePages,
  applyPages,
  finishSaving,
  updatePageFailure,
  updatePageSuccess,
  savePagesFailure,
  savePagesSuccess,
  receiveUpdatedPage,

  deletePage,
  deletePageFailure,
  deletePageSuccess,

  changePageStatus,

  fetchEmptyPhases,
  fetchEmptyPhasesFailure,
  fetchEmptyPhasesSuccess,
  reorderPagesInPhase,

  setByPhase,
  savePageOrder,
  savePageOrderSuccess,
  savePageOrderFailure,
};
